module.exports = __webpack_public_path__ + "img/img1.7823b864.png";